import { apiClient } from '@/shared/api/client'

export interface AppNotificationData {
  type: string
  title: string
  body?: string | null
  project_id?: string | null
  conversation_id?: string | null
  token?: string | null
}

export interface AppNotification {
  id: string
  type: string
  data: AppNotificationData
  read_at: string | null
  created_at: string
}

export async function listNotifications(): Promise<AppNotification[]> {
  const response = await apiClient.get<{ data: AppNotification[] }>('/notifications')
  return response.data.data
}

export async function getUnreadNotificationsCount(): Promise<number> {
  const response = await apiClient.get<{ data: { count: number } }>('/notifications/unread-count')
  return response.data.data.count
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.post(`/notifications/${id}/read`)
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post('/notifications/read-all')
}
